import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25c10a1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame" }
const _hoisted_2 = { class: "title flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = { class: "lineText" }
const _hoisted_5 = { style: {"cursor":"pointer"} }
const _hoisted_6 = { class: "scroll" }
const _hoisted_7 = { class: "ctitle" }
const _hoisted_8 = { class: "cdetail-content" }
const _hoisted_9 = { class: "cdetail" }
const _hoisted_10 = { class: "tooltipText" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))

import { IPostMachineProductionGetWorkOrderInfoByIdInfoDataList } from "@/api/machine/index.type.public";
import JIcon from "@/components/jicon/index.vue";
import { PropType } from "vue";


//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
        required: false,
        type: String,
        default: ""
    },
    listData: {
        required: true,
        type: Array as PropType<IPostMachineProductionGetWorkOrderInfoByIdInfoDataList[]>,
        default: () => {
            return []
        },
    },
},
  emits: ["onConfigFileds"],
  setup(__props, { emit }: { emit: ({
    (e: "onConfigFileds"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



//定义监听事件
//watch(
//  () => props.test,
//  (newVal: any) => {
//    //变更执行事件
//  }
//);

//定义回调事件


//定义生命周期事件
// onMounted(() => {
//     //生命周期处理内容
//     console.log("chushihua")
// });

// ---------------------数据变量定义-------------------------

//变量定义
//let test: any = ref<string>();



// ---------------------方法定义-------------------------

//const testMethon = function (item:string): string {
//  return "";
//};



//------------------监听数据变化-------------

//监听菜单信息变更
// watch(() => props.listData,
//     (newVal: any) => {
//         console.log("ss")
//     }
// );

//-----------------方法定义-------------------
const onConfigFileds = () => {
    emit("onConfigFileds");
};


return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(JIcon, {
          icon: "mes-setting",
          onClick: onConfigFileds,
          size: _ctx.$px2rem('32px'),
          style: {"color":"#606266"}
        }, null, 8, ["size"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listData, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "context",
          key: item.fieldId
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.fieldMean) + "：", 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                trigger: "click"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.fieldValue), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.fieldValue ? item.fieldValue : ''), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ]))
      }), 128)),
      _hoisted_11,
      _hoisted_12
    ])
  ]))
}
}

})